import './App.css';
import { Data } from './Components/Data';
import { Navigation } from './Components/Navigation';

function App() {
  return (
   <div>
    <Navigation/>
    <Data/>
    </div>
  );
}

export default App;
